//? remote components
import React from 'react';
import { GlobalToken, Popover } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { observer } from 'mobx-react';

import IconStacked from '@/assets/icon-stacked.svg?react';

const ButtonStacked = observer(({ active, disabled, ...rest }) => {
  const { t } = useTranslation();

  return (
    <Popover
      placement={'bottomLeft'}
      content={t('Choose only Power parameters to view the Stack layout. You cannot choose the station total power')}
      {...(disabled ? {} : { open: false })}
    >
      <Container
        className={cn({
          active,
          disabled,
        })}
        {...rest}
      >
        <IconStacked />
      </Container>
    </Popover>
  );
});

const Container = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  border-radius: 2px;

  &:hover {
    cursor: pointer;

    path {
      fill: ${({ theme: { token } }) => token.colorText};
    }
  }

  &.active {
    path {
      fill: ${({ theme: { token } }) => token.colorPrimary};
    }
  }

  &.disabled {
    cursor: not-allowed;

    path {
      fill: ${({ theme: { token } }) => token.colorBorderSecondary};
    }
  }
`;

export default ButtonStacked;
